// extracted by mini-css-extract-plugin
export default {"image":"MX-z","loaded":"NX-z"};